import { render } from "./HostExternalCommands.vue?vue&type=template&id=05c54a2c"
import script from "./HostExternalCommands.vue?vue&type=script&lang=js"
export * from "./HostExternalCommands.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__